module.exports = __webpack_public_path__ + "img/magnify-minus.0548b95c.svg";